import { render, staticRenderFns } from "./FlatRoofLightMeasurement.vue?vue&type=template&id=2082bd6a&"
import script from "./FlatRoofLightMeasurement.vue?vue&type=script&lang=js&"
export * from "./FlatRoofLightMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports